module.exports = __webpack_public_path__ + "img/skinbox-black-white.6f2a4567.png";